/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Ups_Rebook_Description_ManyInputs */

const en_orders_ups_rebook_description_many = /** @type {(inputs: Orders_Ups_Rebook_Description_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of the selected orders already have tracking numbers. Do you want to rebook them?`)
};

const es_orders_ups_rebook_description_many = /** @type {(inputs: Orders_Ups_Rebook_Description_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de los pedidos seleccionados ya tienen numero de tracking. Quieres volver a reservarlos?`)
};

/**
* | output |
* | --- |
* | "{count} of the selected orders already have tracking numbers. Do you want to rebook them?" |
*
* @param {Orders_Ups_Rebook_Description_ManyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_ups_rebook_description_many = /** @type {((inputs: Orders_Ups_Rebook_Description_ManyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Ups_Rebook_Description_ManyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_ups_rebook_description_many(inputs)
	return es_orders_ups_rebook_description_many(inputs)
});